export default {
  partners: 'PARTNERS'
};
